import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

import jobTitle from "../../assets/img/Group 532 (3).png";
import Video from "../../assets/img/welcome.mp4";

import Header from "../../SubComponents/Header";
import Footer from "../../SubComponents/footer";
import { API_BASE_URL } from "../../config/config";

import "./style.css";

const JobMain = () => {
  const [categories, setCategories] = useState([]);
  const { t, i18n } = useTranslation();

  const languageMap = { tj: 1, ru: 2, en: 3 };
  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);

    axios
      .get(`${API_BASE_URL}/api/categories?lang=${langCode}&page=1`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        setCategories(response.data.enttities || []);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, [i18n.language]);

  return (
    <>
      <div className="position-relative white-text" style={{ height: "200px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>

      <main className="flex-grow-1 min-h-100">
        <div
          className="container job-main-container"
          style={{ zIndex: 3, position: "relative" }}
        >
          <div className="row">
            <div className="col-12 mb-4">
              <div className="d-flex align-items-center mb-4 flex-wrap">
                <img
                  className="jobportPhoto"
                  src={jobTitle}
                  alt="Job Title Icon"
                />
                <h3 className="ms-2 theJobTitle">{t("Agency Vacancies")}</h3>
              </div>

              <div className="JobDescriptions mb-5">{t("AgencyDecr")}</div>

              <div className="row">
                {categories.length > 0 ? (
                  categories.map((item, index) => (
                    <div key={index} className="col-12 col-sm-6 col-lg-4 mb-4">
                      <Link
                        to={`/job/list/${item.id}`}
                        className="custom-job-link d-block"
                      >
                        <div className="job-category-card d-flex align-items-start">
                          <div className="ms-3 flex-grow-1">{item.name}</div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="col-12">
                    <div className="no-categories-message">
                      <i
                        className="fas fa-briefcase mb-3"
                        style={{ fontSize: "2rem", opacity: 0.6 }}
                      ></i>
                      <p className="mb-0">{t("NoAvailable")}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default JobMain;
